// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import style for web component
import styles from './web-component-style.scss?inline';

/**
 * ProTag Web Component (<uo-pro-tag>)
 * Displays a styled "Pro" label.
 */
@customElement( 'uo-pro-tag' )
class ProTag extends LitElement {
	/**
	 * Define styles for the component.
	 * The styles are imported from an external SCSS file.
	 */
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * The "color" property for the ProTag component.
	 *
	 * @type {String}
	 * @default "primary"
	 */
	@property( { type: String } ) accessor color = "primary";

	/**
	 * The "size" property for the ProTag component.
	 *
	 * @type {String}
	 * @default "size"
	 */
	@property( { type: String } ) accessor size;

	/**
	 * Render the component's HTML template.
	 *
	 * @return {TemplateResult} The HTML template for the component.
	 */
	render() {
		return html`
			<uo-tooltip>
				${ escapeHTML( __( 'Requires Uncanny Automator Pro', 'uncanny-automator' ) ) }

				<div 
					slot="target"
					class="tag"
					color="${ ifDefined( this.color ) }"
					size="${ ifDefined( this.size ) }"
				>
					${ escapeHTML( __( 'Pro', 'uncanny-automator' ) ) }
				</div>
			</uo-tooltip>
		`;
	}
}
